import React, { useState, useEffect, useCallback } from "react";

import Chart from "../chart/chart.component";
import useAppContext from "../../../hooks/useAppContext";
import GenericInputField, {
  TYPES,
} from "../../genericInputFields/genericInputField";
import { chartPeriodData } from "./constants";
import { StyledWrapper } from "./chartPanel.style";

import { Loader } from "@mbo/icons";

const DEFAULT_DAYS_COMPUTE = 14;

const ChartPanel = ({ chartType }) => {
  const { axios } = useAppContext();
  const [data, setData] = useState(null);

  const changeComputePeriod = useCallback(
    (value) => {
      document.body.style.cursor = "wait";
      axios
        .get("admin/chart", {
          params: {
            type: chartType,
            days_compute: value,
          },
        })
        .then((res) => {
          setData(res.data.data);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          document.body.style.cursor = "default";
        });
    },
    [chartType],
  );

  useEffect(() => changeComputePeriod(DEFAULT_DAYS_COMPUTE), []);

  if (!data)
    return (
      <StyledWrapper className="loading">
        <div>
          <Loader size="xxxl" />
        </div>
      </StyledWrapper>
    );

  return (
    <StyledWrapper>
      <GenericInputField
        type={TYPES.SELECT_LABELED}
        placeholder="Select chart period"
        name="payload.found_out_from"
        options={chartPeriodData}
        initialValue={DEFAULT_DAYS_COMPUTE}
        required={false}
        useInForm={false}
        additionalStyles={{
          maxWidth: "unset",
          width: "calc(100% - 16px)",
          margin: "auto",
        }}
        onChange={changeComputePeriod}
      />
      <Chart data={data} className="chart-object" style={{ height: 450 }} />
    </StyledWrapper>
  );
};

export default ChartPanel;
